import { render, staticRenderFns } from "./daishenghe.vue?vue&type=template&id=962ab62e&scoped=true&"
import script from "./daishenghe.vue?vue&type=script&lang=js&"
export * from "./daishenghe.vue?vue&type=script&lang=js&"
import style0 from "./daishenghe.vue?vue&type=style&index=0&id=962ab62e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "962ab62e",
  null
  
)

export default component.exports